module.exports = __webpack_public_path__ + "img/herramienta.10a71eeb.svg";